import { render, staticRenderFns } from "./jurisdiction_list.vue?vue&type=template&id=0b116d35&scoped=true&"
import script from "./jurisdiction_list.vue?vue&type=script&lang=js&"
export * from "./jurisdiction_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b116d35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
